import React, { Fragment, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useField, useFormikContext } from 'formik';
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { toInputUppercase } from '../../../helpers/helpers';
import SuccessModal from "../../forms/ContractAddForm/Modal";
import "./InputField.css";
import Modal from "../../common/Modal/Modal";

export default function InputField(props) {
  const [isSentDataLayer, setIsSentDataLayer] = useState(false);
  const { errorText, labelIcon, infoModalMessage, validationSchema, ...rest } = props;
  const [field, meta] = useField(props);
  const [fieldPass, setFieldPass] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false)

  const { summaryMode } = rest;
  const { t } = useTranslation();
  let labelFormatted = rest.label;
  const { values, setFieldValue } = useFormikContext();
  if (summaryMode) {
    labelFormatted = rest.summaryLabel ? rest.summaryLabel : rest.label;
  }
  const readonlyBoolean =typeof(rest.readonly)==="function" ? rest.readonly(values) : rest.readonly;
  const disabledBoolean =typeof(rest.disabled)==="function" ? rest.disabled(values) : rest.disabled;
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  return (
    <Form.Group noValidate
    >
      {!summaryMode ? (
          <>
            {labelFormatted && <Form.Label
              className="paragraph-small-fs9"
              htmlFor={field.name}
              >
              {labelFormatted}
              {props.message ? 
              <button
                type="button"
                className={"form-info-button"}
                aria-label={t("aria.form.info.button")}
                aria-haspopup="dialog"
                aria-controls={field.name + "-info-modal"}
                onClick={() => {
                  setFieldPass(true)
                }}
              >
                <span className="form-icon-info" aria-hidden="true"></span>
              </button> : null}
                  {
                    labelIcon && (
                      <button
                        type="button"
                        className={"form-info-button"}
                        aria-label={t("aria.form.info.button")}
                        aria-haspopup="dialog"
                        aria-controls={field.name + "-info-modal"}
                        onClick={() => setShowInfoModal(true)}>
                      <span className="form-icon-info" aria-hidden="true"></span></button>
                    )
                  }
              </Form.Label>
            }
            <Fragment>
              <Form.Control
                type={rest.inputType || "text"}
                name={field.name}
                onPaste={rest.onPaste ? (e) => e.preventDefault() : () => {
                }}
                onCopy={rest.onCopy ? (e) => e.preventDefault() : () => {
                }}
                // to deal with the translations for the plaholder [object Object]
                placeholder={typeof rest.placeholder === 'object' ? t(rest.placeholder.props.i18nKey) : rest.placeholder}
                value={field.value || ''}
                onChange={rest.onChange ? (e) => rest.onChange(setFieldValue, field.onChange, e) : field.onChange}
                onBlur={rest.onBlur ? () => rest.onBlur(isSentDataLayer, setIsSentDataLayer) : null}
                className={(meta.touched && meta.error) ? "is-invalid" : ""}
                disabled={disabledBoolean}
                readOnly={readonlyBoolean}
                onInput={rest.uppercase ? toInputUppercase : null}
                aria-describedby={(meta.touched && meta.error) ? field.name + "-error" : null}
                required={isRequired}
                id={field.name}
              />
              {(meta.touched && meta.error) &&
                <p className="form-error-text paragraph-small-form" role="alert" id={field.name + "-error"}>{meta.error}</p>}
            </Fragment>
          </>
        ) : (
          <>
            <div className="form-group-info">
              {labelFormatted && 
              <span className="paragraph-small-fs9" >
                {labelFormatted}
              </span>
              }
              {labelFormatted && props.message ? <button
                  type="button"
                  className={"form-info-button"}
                  aria-label={`${t("aria.form.info.button")}[${renderToString(labelFormatted)}]`}
                  aria-haspopup="dialog"
                  aria-controls={field.name + "-info-modal"}
                  onClick={() => {
                    setFieldPass(true)
                  }}
                > <span className="form-icon-info" aria-hidden="true"></span></button> : null}
                {labelFormatted &&
                  labelIcon && (
                    <button
                      type="button"
                      className={"form-info-button"}
                      aria-label={`${t("aria.form.info.button")}[${renderToString(labelFormatted)}]`}
                      aria-haspopup="dialog"
                      aria-controls={field.name + "-info-modal"}
                      onClick={() => setShowInfoModal(true)}>
                        <span className="form-icon-info"
                              aria-hidden="true">
                        </span>
                    </button>
                  )
                }  
            </div>
            <SummaryItem value={field.value} error={meta.error} />
          </>
        )
      }
      {(labelIcon && infoModalMessage) &&
      <Modal
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        type={"button"}
        onFirstClick={() => setShowInfoModal(false)}
        linkTitle={t("common.hoCapito")}
        description={infoModalMessage}
      />}

      {fieldPass ?
      <Modal
        show={fieldPass}
        onClose={() => setFieldPass(false)}
        type={"button"}
        onFirstClick={() => setFieldPass(false)}
        linkTitle={t("common.hoCapito")}
        description={t(props.messageText)}
      /> : null}
      {props.subtitle ?
        <p className="paragraph-small-form">{props.subtitle}</p> : null}

    </Form.Group>
  );
}
